
export enum Exchange {
    AOM = "AOM", // AUS_OPTION_MARKET
    ASX = "ASX", // AUS_STOCK_EXCHANGE
    AXW = "AXW", // AUS_WARRANT_EXCHANGE
    AXF = "AXF", // AUS_FUTURES_EXCHANGE
    CXA = "CXA", // CHI-X
    NSX = "NSX"
}
